<template>
  <v-container>
    <v-col cols="12">
      <v-img src="@/assets/logo_new.png" width="150" style="margin: auto" />
    </v-col>

    <v-row
      cols="12"
      class="d-flex align-center justify-center"
      style="height: 50%; font-size: 14px"
    >
      <div class="col-12">
        <div class="col-12 d-flex align-center mb-4">
          <v-icon medium class="mr-2" color="#fec70f">mdi mdi-account</v-icon>
          <div style="color: #000; font-size: 1.2em; font-weight: 400">
            Tus datos
          </div>
        </div>
        <div class="col-12 d-flex align-center mb-4">
          <v-icon
            medium
            class="mr-2"
            :color="currentStep == 2 || currentStep == 3 ? '#fec70f' : '#000'"
            >mdi mdi-file-document-outline</v-icon
          >
          <!-- <div style="font-size: 1.2em; font-weight: 400;" :class="currentStep == 2 || currentStep == 3 ? 'violet' : 'text-white'">Documentación</div> -->
          <div style="font-size: 1.2em; font-weight: 400">Documentación</div>
        </div>
        <div class="col-12 d-flex align-center mb-4">
          <v-icon
            medium
            class="mr-2"
            :color="currentStep == 3 ? '#fec70f' : '#000'"
            >mdi mdi-domain</v-icon
          >
          <div style="font-size: 1.2em; font-weight: 400">Empresa</div>

          <!-- <div style="font-size: 1.2em; font-weight: 400;" :class="currentStep == 3 ? 'violet' : 'text-white'">Empresa</div> -->
        </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "status-component",

  props: ["currentStep"],
};
</script>

<style>
.violet {
  color: #fec70f;
}
.text-white {
  color: #fff;
}
</style>
